import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/index.vue' // 首页
import Introduction from '@/view/introduction.vue' // 企业简介
import History from '@/view/history.vue' // 发展历程
import Culture from '@/view/culture.vue' // 企业文化
import Download from '@/view/download.vue' // 下载PDF简介
import Devs from '@/view/devs.vue' // DEVS
import Plan from '@/view/plan.vue' // 行业方案
import Case from '@/view/case.vue' // 客户案例
import Casedetail from '@/components/casedetail.vue' // 客户案例详情
import Newup from '@/view/newup.vue' // DVES最新更新
import newupCms from '@/view/newupCms.vue' // CMS最新更新
import Help from '@/view/help.vue' // 寻求帮助
import Contact from '@/view/contact.vue' // 联系我们
import Wait from '@/view/wait.vue' // 等待
import Recruit from '@/view/recruit.vue' //招聘
import Recruitdetail from '@/view/Recruitdetail' // 招录详情
import Question from '@/view/question' // 常见问题ist
import ArticleDetail from '@/view/detail' //公告详情
import ArticleList from '@/view/gonggao' //公告列表
import CompanyProduct from '@/view/companyProduct' //公告列表
import HeZuoPeople from '@/view/hezuoPeople' //公告列表

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/introduction',
      name: 'Introduction',
      component: Introduction
    },
    {
      path: '/history',
      name: 'History',
      component: History
    },
    {
      path: '/culture',
      name: 'Culture',
      component: Culture
    },
    {
      path: '/download',
      name: 'Download',
      component: Download
    },
    {
      path: '/devs',
      name: 'Devs',
      component: Devs
    },
    {
      path: '/plan',
      name: 'Plan',
      component: Plan
    },
    {
      path: '/case',
      name: 'Case',
      component: Case
    },
    {
      path: '/casedetail',
      name: 'Casedetail',
      component: Casedetail
    },
    {
      path: '/newup',
      name: 'Newup',
      component: Newup
    },
    {
      path: '/newupCms',
      name: 'newupCms',
      component: newupCms
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/wait',
      name: 'Wait',
      component: Wait
    },
    {
      path: '/recruit',
      name: 'Recruit',
      component: Recruit
    },
    {
      path: '/recruitdetail',
      name: 'Recruitdetail',
      component: Recruitdetail
    },
    {
      path: '/question',
      name: 'Question',
      component: Question
    },
    {
      path: '/articleDetail',
      name: 'ArticleDetail',
      component: ArticleDetail
    },
    {
      path: '/articleList',
      name: 'articleList',
      component: ArticleList
    },
    {
        path: '/softwareList',
        name: 'softwareList',
        component: CompanyProduct
    },
    {
        path:"/hezuoConpany",
        name:"HeZuoPeople",
        component:HeZuoPeople
    }
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js